'use client';

import { Share } from 'lucide-react';

import notify from '@/utils/shared/notify';
import { Button } from '../button';
import { ReactNode } from 'react';
import * as React from 'react';

type ShareButtonProps = {
  data: ShareData;
  children: ReactNode;
} & React.ComponentProps<typeof Button>;

export function ShareButton({ data, children, ...rest }: ShareButtonProps) {
  const handleShare = async () => {
    try {
      if (typeof navigator.share !== 'function' || !navigator.canShare(data)) {
        notify.error('Delning stöds inte på din enhet. Testa att kopiera.');
        return;
      }

      await navigator.share(data);
    } catch (err) {
      console.error('Failed to share link: ', err);
    }
  };

  return (
    <Button onClick={handleShare} aria-label={'Share'} {...rest}>
      <div className="relative w-4 h-4">
        <Share className={'absolute transition-opacity duration-200 opacity-100'} data-slot="icon" size={16} aria-hidden="true" />
      </div>
      {children}
    </Button>
  );
}
